// Background Cipher Lock heal (cc_25): heal-only ensures driven by WS frames + GET /pqc/heal-queue.
// Never mints a session — that only happens on chat open / send (ensureChatCipher without healOnly).
import { toast } from "sonner";
import { api } from "./clApi";
import { ensureChatCipher, ensureGroupCipher } from "./cipherlock";

const inflight = new Map(); // "chat:<id>" | "circle:<id>" -> Promise<number>

function once(key, fn) {
  if (inflight.has(key)) return inflight.get(key);
  const p = fn().catch(() => 0).finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
}

/** Heal-only ensure for one DM. Resolves the number of session keys that just became readable. */
export function healChat(userId, chatId) {
  return once(`chat:${chatId}`, async () => (await ensureChatCipher(userId, chatId, { healOnly: true })).unlocked || 0);
}

/** Heal-only ensure for one BLOQ (group ensure never mints). */
export function healCircle(userId, circleId) {
  return once(`circle:${circleId}`, async () => (await ensureGroupCipher(userId, circleId)).unlocked || 0);
}

/** Pull the server's heal-queue (fail-soft on pre-cc_25 backends) and heal every listed space. */
export async function runHealQueue(userId) {
  let q;
  try {
    q = await api("/pqc/heal-queue");
  } catch {
    return 0;
  }
  const jobs = [
    ...(q?.chats || []).map((id) => healChat(userId, id)),
    ...(q?.circles || []).map((id) => healCircle(userId, id)),
  ];
  const counts = await Promise.all(jobs);
  return counts.reduce((a, b) => a + b, 0);
}

let lastToastAt = 0;
/** "Unlocking older messages…" — throttled so a burst of frames yields one toast. */
export function notifyUnlocked(count) {
  if (!count) return;
  const now = Date.now();
  if (now - lastToastAt < 4000) return;
  lastToastAt = now;
  toast("Unlocking older messages…", {
    description: `${count} encrypted ${count === 1 ? "session is" : "sessions are"} now readable on this device`,
    id: "cipherlock-unlock",
  });
}
